import { selectIsBEFHOnlyCustomer } from '../../feature-modules/accounts/store/accounts.selector';
import { selectIsStatelessCasCustomer } from '../../feature-modules/customer-attributes/store/customer-attributes.selector';
import { createSelector } from '@ngrx/store';

export const selectIsRedirectedBEFHOnlyCustomer = createSelector(
  selectIsBEFHOnlyCustomer,
  selectIsStatelessCasCustomer,
  (isBEFHOnlyCustomer, isStatelessCasCustomer) => isBEFHOnlyCustomer && isStatelessCasCustomer
);
